import { FC } from 'react';
import { FormCurrencyFieldProps } from './types';
import { CalculatorHeading } from '@components/common/CalculatorHeading/CalculatorHeading';
import { CalculatorText } from '@components/common/CalculatorText/CalculatorText';
import { FormCurrencyField } from '@components/common/FormCurrencyField/FormCurrencyField';
import { FormSelect } from '@components/common/FormSelect/FormSelect';
import { useIntl } from 'react-intl';

export const CalculatorCurrencyField: FC<FormCurrencyFieldProps> = ({
  name,
  textKey,
  titleKey,
  rules,
  className,
  isPeriod,
  periodProps,
  textHref,
  textFieldProps,
  shouldShowAdornment = false,
}) => {
  const intl = useIntl();

  return (
    <div className={className}>
      <CalculatorHeading labelKey={titleKey} />
      {textKey && <CalculatorText labelKey={textKey} href={textHref} />}
      <div className={'mt-2 flex items-start'}>
        <FormCurrencyField
          name={name}
          className={'min-w-0 flex-1'}
          textFieldProps={{ ...textFieldProps, placeholder: intl.formatMessage({ id: 'numbers.0' }) }}
          numericFormatProps={{ decimalScale: 0 }}
          rules={rules}
          shouldShowAdornment={shouldShowAdornment}
        />
        {isPeriod && periodProps && (
          <FormSelect
            name={name + 'Period'}
            className={'xs:w-3/5 ml-2 w-2/5 shrink-0 md:ml-6 md:w-1/3'}
            rules={periodProps.rules}
            options={periodProps.options}
            selectProps={periodProps.selectProps}
            selectInputProps={{
              placeholder: intl.formatMessage({ id: periodProps?.placeholderKey || 'placeholders.select' }),
            }}
          />
        )}
      </div>
    </div>
  );
};
